import React from 'react';
import ContactCard from './ContactCard';
import styles from './ContactInfo.module.css';
import { atomicDividerVertical ,atomicDividerHorizontal  } from '@filament/react/styles';

const contactData = [
  {
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/TEMP/623edcd7575181baaa64326a883f819cec3b84016426c8204e43d7b2bae3a277?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    name: "Ram Viswanathan",
    role: "Digital Employee Experience Leader (IT Platform)",
    email: "ramkumar.viswanathan@philips.com"
  },
  {
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/TEMP/2092f8a0594091f2bb4cfd1d9cb70fb0c0f8f40657c4a066af8797d1e2fa6463?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    name: "Rakesh Doddamane",
    role: "Lead User Experience (IT Platform)",
    email: "rakesh.doddamane@philips.com"
  }
];

const ContactInfo = () => {
  return (
    <section className={styles.contactUs}>
      <header className={styles.contactHeader}>
        <h2 className={styles.headerTitle}>Need more info?</h2>
        <p className={styles.headerSubtitle}>Reach out to</p>
      </header>
      <div className={styles.contactList}>
        <div className={styles.contactWrapper}>
          {contactData.map((contact, index) => (
            <React.Fragment key={contact.email}>
              <ContactCard {...contact} />
              {index < contactData.length - 1 && (
                <img 
                  loading="lazy" 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/99df1cb125586bb1e0d6d67d7c13bbdc0f21c7aa79c054d1576bd52263b7acb5?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5" 
                  alt="" 
                  className={styles.separatorIcon} 
                  aria-hidden="true"
                />
                
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;